import script from "./practiceVoca-page.vue?vue&type=script&lang=ts&setup=true"
export * from "./practiceVoca-page.vue?vue&type=script&lang=ts&setup=true"

import "./practiceVoca-page.vue?vue&type=style&index=0&id=f28355c4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f28355c4"]])

export default __exports__